function Accordion(el) {
    this.el = el;

    this.el.addEventListener('click', e => {
        if (e.target.classList.contains('jsAccordionLineTitle')) {
            this.toggleElement(e.target.closest('li'));
        }
    });
}

Accordion.prototype.toggleElement = function(el) {
    if (el.classList.contains('open')) {
        this._closeElement(el);
    }
    else {
        // Find all open elements and close them
        const openEls = this.el.querySelectorAll('li.open');
        if (openEls) openEls.forEach(el => this._closeElement(el));

        // Open this element
        this._openElement(el);
    }
};

Accordion.prototype._openElement = function(el) {
    const oldHeight = el.offsetHeight;

    // Get the element height when expanded
    el.classList.add('open');
    const newHeight = el.offsetHeight;
    el.classList.remove('open');

    gsap.timeline()
        .set(el, { height: oldHeight })
        .add(_ => el.classList.add('open'))

        .to(el, { duration: 0.25, height: newHeight, ease: Power2.easeInOut })
        .set(el, { clearProps: 'all' })
    ;
};

Accordion.prototype._closeElement = function(el) {
    const oldHeight = el.offsetHeight;
    const expandableEl = el.querySelector('.jsAccordionLineExpandable');

    // Get the element height when closed
    el.classList.remove('open');
    const newHeight = el.offsetHeight;
    el.classList.add('open');


    gsap.timeline()
        .set(el, { height: oldHeight })
        .set(expandableEl, { display: 'block' })
        .add(_ => el.classList.remove('open'))

        .to(el, { duration: 0.25, height: newHeight, ease: Power2.easeInOut })
        .set([el, expandableEl], { clearProps: 'all' })
    ;
    
};

(function() {
    const accordionEls = document.querySelectorAll('.jsAccordion');
    accordionEls.forEach(el => new Accordion(el));
})();